import * as React from 'react';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { Dialog } from '@progress/kendo-react-dialogs';
import { createStyles, makeStyles } from '@material-ui/core';
import StringResourceManager from '../StringResourceManager';

const useStyles = makeStyles(theme =>
  createStyles({
    modalContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(2),
      justifyContent: 'center',
      padding: theme.spacing(2),
    },
    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      width: 120,
      height: 120,
      border: '2px solid #ccc',
      borderRadius: theme.shape.borderRadius,
      overflow: 'hidden',
      position: 'relative',
      cursor: 'pointer',
      '&:hover': {
        borderColor: '#007bff',
      },
    },
    image: {
      borderRadius: theme.shape.borderRadius,
      objectFit: 'cover',
      transition: 'border-color 0.3s ease',
    },
    filename: {
      marginTop: theme.spacing(1),
      textAlign: 'center',
      color: '#333',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  }),
);

interface Props {
  handleCloseDialog: (open: boolean) => void;
  imageList: string[];
  setSelectedImage?: (imageSelected: string) => void;
}

const ImageDialog: React.FC<Props> = ({
  handleCloseDialog,
  imageList,
  setSelectedImage,
}): React.ReactElement => {
  const classes = useStyles();

  const handleClose = () => {
    handleCloseDialog(false);
  };

  const getFilename = (url: string): string => {
    const path = url.split('?')[0];
    const parts = path.split('/');
    const filenameWithExt = parts[parts.length - 1];
    const filenameParts = filenameWithExt.split('.');
    return filenameParts.slice(0, -1).join('.');
  };

  const getFilenameStyle = (filename: string) => {
    const fontSize = filename.length >= 20 ? '0.5rem' : '0.75rem';
    return { fontSize };
  };

  return (
    <Dialog
      style={{ zIndex: 10000 }}
      height="65vh"
      width="45vw"
      title={
        <StringResourceManager
          variant="body1"
          style="commandLabel"
          stringKey={'SELECT_IMAGE'}
          gutterBottom={true}
        />
      }
      onClose={handleClose}
    >
      <div className={classes.modalContainer}>
        {imageList.map(url => {
          const filename = getFilename(url);
          return (
            <div
              key={url}
              className={classes.imageContainer}
              onClick={() => (setSelectedImage ? setSelectedImage(url) : null)}
            >
              <img src={url} alt="Uploaded" className={classes.image} />
              <div
                className={classes.filename}
                style={getFilenameStyle(filename)}
              >
                {filename}
              </div>
            </div>
          );
        })}
      </div>
    </Dialog>
  );
};

export default ImageDialog;
